import { render, staticRenderFns } from "./AdvertisingModal.vue?vue&type=template&id=6078cbfb&scoped=true"
import script from "./AdvertisingModal.vue?vue&type=script&lang=js"
export * from "./AdvertisingModal.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingModal.vue?vue&type=style&index=0&id=6078cbfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078cbfb",
  null
  
)

export default component.exports